import React from 'react';
import { Agent, AgentStatus } from '../../model';
import FileUploadComponent from '../FileUploadComponent';
import './AgentFileUpload.scss';

export interface AgentFileUploadProps {
  agent: Agent | null;
}

const AgentFileUpload: React.FC<AgentFileUploadProps> = ({ agent }) => {
  if (!agent) return null;

  const isRagDisabled = agent.status !== AgentStatus.AWAITING_FILE_UPLOAD;

  if (isRagDisabled) {
    return (
      <div className="agent-file-upload">
        <div className="agent-file-upload__disabled">
          <h3>RAG Data Upload</h3>
          <p>
            File upload is only available when agent status is "Awaiting File
            Upload". Current status: {agent.status}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="agent-file-upload">
      <h3>RAG Data Upload</h3>
      <p>
        Upload a JSON file containing RAG (Retrieval-Augmented Generation) data
        for this agent.
      </p>

      <FileUploadComponent agentUuid={agent.uuid!} />
    </div>
  );
};

export default AgentFileUpload;
